export function assertUnreachable(_x) {
  throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}